import React from "react";
import { formatVideoDuration, formatThousend } from "@Src/utils/helper";
class HotVideoList extends React.Component {
  io = null;

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.scrollWatch(this.el);
  }

  scrollWatch = (el) => {
    const { onEntries } = this.props;
    let isFrist = false;

    try {
      this.io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !isFrist) {
            isFrist = true;
            onEntries();
          }
        },
        { threshold: [0.65] },
      );
      if (el) {
        this.io.observe(el);
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { data, imgClass, onClick, itemG4Class } = this.props;

    return (
      <div className={`w-full text-white mb-20`} ref={(el) => (this.el = el)}>
        <a href={`/movies/${data.id}`} className={`${itemG4Class} w-full inline-block`} onClick={() => onClick()}>
          <div className='flex justify-center items-center flex-col'>
            <div className='w-full mb-8 relative'>
              <img className={`${imgClass} w-full h-106 object-cover`} src={data.thumb} />
              <div className='w-32 h-40 absolute bottom-0 top-0 left-0 right-0 m-auto'>
                <img className='w-full h-full' src='https://photo.8891.com.tw/2023/08/15/1692090155275148.png' />
              </div>
              <div className='bg-[#333] text-white absolute bottom-0 right-0 text-12 px-2'>
                {data.play_time || formatVideoDuration(data.playTime)}
              </div>
            </div>
            <div className='flex items-center justify-between flex-col w-full'>
              <h4 className='h-34 leading-18 text-[#333] text-14 w-full line-clamp-2'>{data.title}</h4>
              <div className='w-full h-14 leading-14 mt-8 flex justify-between'>
                {data.author !== "" && <span className='text-12 text-[#999999]'>{data.author}</span>}
                {data.visits !== "" && (
                  <span className='text-12 text-[#999999]'>播放{data.visits || formatThousend(data.views)}次</span>
                )}
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default HotVideoList;
